export enum LocalStorageKeys {
  FparCldbSelectedGrant = 'FparCldbSelectedGrant',
  FparReviewPortalSelectedGrant = 'FparReviewPortalSelectedGrant',
  FparSecurityNoticeShown = 'FparSecurityNoticeShown',
  FparUserAppState = 'FparUserAppState',
  UserGrantSelection = 'UserGrantSelection',
}
